// Backend API base URL. Set REACT_APP_API_URI in env to override.
// Fallback uses the deployed backend so production works even without env.
const uri =
  window.location.hostname.includes("localhost") ||
  process.env.NODE_ENV === "development"
    ? ""
    : process.env.REACT_APP_API_URI || "https://shopbuddy-backend.vercel.app";

console.log("Config loaded. NODE_ENV:", process.env.NODE_ENV, "URI:", uri);

export default uri;
